/**
 * Asynchronously load quickshop bundle at runtime (if necessary) and launch quickshop
 * @param  {Object} store        Redux store
 * @param  {Object} options      Config flags for quickshop (see category/js/utils/categoryQuickshopOptions.js)
 * @param  {Object} e            Event from event handler that triggered the quickshop launch
 * @param  {Array}  records      Array of product data used by QuickshopProductsGenerator
 * @param  {Number} productIndex Integer index of records argument that indicates initial product to show
 * @param  {String} tileKey      Look for quickshop tile data under a key inside of records argument
 * @return {Promise}             Promise for clients to chain logic that should only happen after quickshop has launched
 */
export function launchAsyncQuickshop(store, options, e, records, productIndex = 0, tileKey = null) {
    return import('@product/js/utils/async/quickshopLoader').then(({
        quickshopStartingSagas,
        launchQuickshopSaga,
        QuickshopProductsGenerator,
        quickshopSagasInitialized
    }) => {
        const state = store.getState();
        const sagasInitialized = _.get(state, 'core.quickshopSagasInitialized', false);

        if (!sagasInitialized) {
            quickshopStartingSagas.forEach((saga) => {
                store.runSaga(saga);
            });
            store.dispatch(quickshopSagasInitialized(true));
        }

        const productsGenerator = new QuickshopProductsGenerator(records, productIndex, tileKey);

        // Returning the promise that is attached to sagas in case clients need to chain actions after
        // quickshop is launched.  It can be ignored otherwise
        return store.runSaga(launchQuickshopSaga, options, productsGenerator, e).done;
    });
}

/**
 * Asynchronously load Write Review bundle at runtime (if necessary) and launch modal
 * @param  {Object}  store              Redux store
 * @param  {Object}  e                  Event from event handler that triggered the write review launch
 * @return {Promise}                    Promise for clients to chain logic
 */
export function launchAsyncWriteReview(store, e) {
    return import('@product/js/utils/async/writeReviewLoader').then(({
        handleReviewsLoginSaga,
        showWriteReviewSaga,
        submitPhotoUploadSaga,
    }) => {
        store.runSaga(showWriteReviewSaga, e);
        store.runSaga(submitPhotoUploadSaga);
    });
}

let productBopisChangeStoreSagasInitialized = false;

/**
 * Asynchronously load bopis change store at runtime (if necessary) and launch the modal
 * @param  {Object} store        Redux store
 * @param  {Object} e            Event from event handler that triggered the bopis change store modal
 * @param  {Object} component    Component launching the modal
 * @return {Promise}             Promise for clients to chain logic that should only happen after modal has launched
 */
export function launchAsyncBopisChangeStore(store, e, component) {
    return import('@product/js/utils/async/bopisChangeStoreLoader').then(({
        pushModalTransition,
        findStoresSaga,
        bopisChangeStoreInit
    }) => {
        if (!productBopisChangeStoreSagasInitialized) {
            store.runSaga(findStoresSaga);
            productBopisChangeStoreSagasInitialized = true;
        }

        const payload = pushModalTransition(
            bopisChangeStoreInit, component.getInheritedOverrides(), e, component.name
        );

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });
}
